import { Component, OnInit } from '@angular/core';
import { CustomersService } from 'src/app/services/core/quickbook/customers/customers.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { sweetAlert } from 'src/app/utils/swal';
import { Router } from '@angular/router';
import { debounceTime, filter, Subject } from 'rxjs';

@UntilDestroy()

@Component({
  selector: 'app-customers-list',
  templateUrl: './customers-list.component.html',
  styleUrls: ['./customers-list.component.css']
})
export class CustomersListComponent implements OnInit {
  customers: any;
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  numberOfRecords = NUMBER_OF_RECORDS;
  search: any = '';
  private searchSubject = new Subject<string>();
  loadingId = null;
  customerDetail: any;
  customerModalObj: any;
  selectedDropdownIndex: any;
  toggleActionButtons = false;

  constructor(
    private router: Router,
    private customerService: CustomersService
  ) { }

  ngOnInit() {
    this.initializeSearch();
    this.getAllCustomers(this.currentPage);
  }

  getAllCustomers(page: any) {
    let queryParams:any = {
      limit: this.numberOfRecords,
      page
    }
    if (this.search) {
      const trimmedSearch = this.search.trim();
      queryParams.search = trimmedSearch;
    }
    this.customerService.getCustomers(queryParams)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.customers = data.results;
            this.totalPages = data.totalPages;
            this.totalResults = data.totalResults;
          }
        },
        error: (err) => {
          sweetAlert("Error", err, "error", "Ok");
        },
        complete: () => {
          console.log('Customer data fetch complete.');
        }
      });
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllCustomers(page);
  }

  async onSyncCustomer(customer: any, type: any) {
    const mPull = `Are you sure you want to overwrite customer data with quickbooks data?`
    const mPush = 'Are you sure you want to overwrite the qucikbooks data with customer data'
    const result = await sweetAlert('Alert', type === 'pull' ? mPull : mPush, 'warning', 'Yes', 'No');
    if (!result.value) return;
      
    if (type === 'pull') customer.pulling = true; else customer.pushing = true;
    const queryParams = {
      isSyncFrom: type === 'pull' ? true : false
    }
    
    this.customerService.syncCustomer(customer.id, queryParams).subscribe(
      {
        next: (data: any) => {
          this.getAllCustomers(this.currentPage);
          sweetAlert('Success', data?.message || 'Synced successfully', 'success', 'Ok');
        },
        error: (err) => {
          console.error(err);
          sweetAlert('Error', err, 'error', 'Ok');
          customer.pulling = false;
          customer.pushing = false;
        },
        complete: () => {
          customer.pulling = false;
          customer.pushing = false;
        }
      })
  }

   opendetailModal(item: any) {
    this.customerDetail = item;
  }


  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500), // wait for typing to stop
        filter((search: any) => !search || search.length >= 3)  // only trigger if >=3 chars OR empty (to reset search)
      ).subscribe(() => {
        this.currentPage = 1;
        this.getAllCustomers(this.currentPage);
      });
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }

  openEditModal(customer: any) {
    this.customerModalObj = customer;
  }

  onCloseModal() {
    this.customerModalObj = null;
  }

  onSaveModal(evt: any) {
    if (evt) {
      this.getAllCustomers(this.currentPage);
    }
    this.customerModalObj = null;
  }

  showActionButtons(idx: any) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt: any) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }
}
